import { Col, Row, Result } from 'antd';
import React from 'react';

function Error() {
    return (
        <div>
           <div className="mt-content">
                <Row style={{ marginTop: 64 }}>
                    <Col push={6} span={12}>
                      <Result
                        status="500"
                        title="出現錯誤!"
                        subTitle="出現錯誤. 請重新載入頁面." />
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default Error;
